import { gql } from '@apollo/client';
import { useQueryCoordinate, useMutationCoordinate } from '../graphql.hooks';

// Types
export interface Portfolio {
  portfolioKey: number;
  userKey: number;
  accountId: string;
  portfolioName: string;
  nickname: string;
  brokerName: string;
  accountType: string;
  user?: {
    userKey: number;
    email: string;
    firstName: string;
    lastName: string;
  };
}

export interface PortfolioLpoa {
  portfolioLpoaKey: number;
  portfolioKey: number;
  envelopeId: string | null;
  signedAt: Date | null;
  rejectedAt: Date | null;
  revokedAt: Date | null;
  activatedAt: Date | null;
  rejectedReason: string | null;
  createdAt: Date;
  portfolio: Portfolio;
}

export interface UserPortfolioLpoaFetchInput {
  userKey: number;
}

export interface UserPortfolioLpoaFetchResponse {
  UserPortfolioLpoaFetch: PortfolioLpoa[];
}

export interface LpoaEnvelopeCreateInput {
  envelopeId: string;
  brokerName: string;
  portfolioKeys?: number[];
}

export interface LpoaEnvelopeCreateResponse {
  LpoaEnvelopeCreate: {
    success: boolean;
    message: string;
  };
}

// Queries
const USER_PORTFOLIO_LPOA_FETCH_QUERY = gql`
  query UserPortfolioLpoaFetch($input: UserPortfolioLpoaFetchInput!) {
    UserPortfolioLpoaFetch(input: $input) {
      portfolioLpoaKey
      portfolioKey
      envelopeId
      signedAt
      rejectedAt
      revokedAt
      rejectedReason
      activatedAt
      createdAt
      portfolio {
        portfolioKey
        userKey
        accountId
        portfolioName
        nickname
        brokerName
        accountType
      }
    }
  }
`;

// Mutations
const LPOA_ENVELOPE_CREATE_MUTATION = gql`
  mutation LpoaEnvelopeCreate($input: LpoaEnvelopeCreateInput!) {
    LpoaEnvelopeCreate(input: $input) {
      success
      message
    }
  }
`;

// Hooks
export const useUserPortfolioLpoaFetch = (input: { userKey?: number }, options: any = {}) => {
  return useQueryCoordinate(USER_PORTFOLIO_LPOA_FETCH_QUERY, {
    ...options,
    variables: input.userKey !== undefined ? { input: { userKey: input.userKey } } : undefined,
    skip: input.userKey === undefined,
  });
};

export const useLpoaEnvelopeCreate = (options = {}) => {
  return useMutationCoordinate(LPOA_ENVELOPE_CREATE_MUTATION, options);
};